import { connectRefinementList } from "instantsearch.js/es/connectors/index.js";

// Show the sidebar filters checkbox
export const chamfrRefinementList = connectRefinementList(
  (renderOptions, isFirstRender) => {
    const {
      items,
      refine,
      isShowingMore,
      canToggleShowMore,
      toggleShowMore,
      widgetParams,
    } = renderOptions;

    const container = widgetParams.container;

    if (isFirstRender) {
      container.innerHTML = `
			<div class="refinement-search" style="display: none;">
				<input type="search" class="refinement-search-input" placeholder="Search..." />
			</div>
			<div class="filter-box-content"></div>
			<a href="javascript:void(0);" class="show-more-btn" style="display: none;">Show more</a>
		`;
    }

    const contentEl = container.querySelector(".filter-box-content");
    const showMoreBtn = container.querySelector(".show-more-btn");

    // Auto-select default values for availability filter when items become available
    if (widgetParams.attribute === "availability" && items.length > 0) {
      // Initialize a flag on the container to track if defaults have been applied
      if (!container.dataset.defaultsApplied) {
        const defaultValues = ["In Stock", "Quick Turn"];
        const refinedValues = items
          .filter((item) => item.isRefined)
          .map((item) => item.label);

        // Only apply defaults if no refinements exist at all (fresh load, not from URL/user)
        if (refinedValues.length === 0) {
          // Find and refine both default values
          let refinementsApplied = false;
          defaultValues.forEach((value) => {
            const item = items.find((item) => item.label === value);
            if (item && !item.isRefined) {
              refine(item.value);
              refinementsApplied = true;
            }
          });

          // Mark as applied to avoid repeated refinements
          container.dataset.defaultsApplied = "true";

          // Return early if we applied refinements - they will trigger a re-render
          if (refinementsApplied) {
            return;
          }
        } else {
          // Mark as applied even if already refined (user or URL state)
          container.dataset.defaultsApplied = "true";
        }
      }
    }

    // Custom sorting for availability: In Stock, Quick Turn, Out of Stock
    let sortedItems;

    const hasYes = items.some((item) => item.label === "Yes");
    const hasNo = items.some((item) => item.label === "No");
    const isYesNo = items.length === 2 && hasYes && hasNo;

    if (widgetParams.attribute === "availability") {
      const availabilityOrder = ["In Stock", "Quick Turn", "Out of Stock"];
      sortedItems = [...items].sort((a, b) => {
        const indexA = availabilityOrder.indexOf(a.label);
        const indexB = availabilityOrder.indexOf(b.label);
        // If not found in order array, sort alphabetically at the end
        if (indexA === -1 && indexB === -1)
          return a.label.localeCompare(b.label);
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
    } else if (isYesNo) {
      const yesNoOrder = ["Yes", "No"];
      sortedItems = [...items].sort((a, b) => {
        const indexA = yesNoOrder.indexOf(a.label);
        const indexB = yesNoOrder.indexOf(b.label);
        return indexA - indexB;
      });
    } else {
      sortedItems = [...items].sort((a, b) => a.label.localeCompare(b.label));
    }

    // Render checkboxes
    contentEl.innerHTML = `
		${sortedItems
      .map(
        (item) => `
			<div class="checkbox-list-item">
				<label class="checkbox-list-label">
					<input
						type="checkbox"
						class="checkbox-list-checkbox"
						value="${item.value.replaceAll('"', "&quot;")}"
						${item.isRefined ? "checked" : ""}>
					<span class="checkbox-list-text">${item.label
            .toString()
            .replace(/\//g, "/\u200B")}</span>
					<span class="checkbox-list-count">(${item.count})</span>
				</label>
			</div>
		`,
      )
      .join("")}
	`;

    // Add checkbox event listeners
    const checkboxes = contentEl.querySelectorAll(".checkbox-list-checkbox");
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (event) => {
        refine(event.target.value);
      });
    });

    // Show or hide the "Show more" button
    if (canToggleShowMore) {
      showMoreBtn.style.display = "";
      showMoreBtn.textContent = isShowingMore ? "Show less" : "Show more";
      showMoreBtn.onclick = () => toggleShowMore();
    } else {
      showMoreBtn.style.display = "none";
    }

    const filterContainer = container.closest(".filter-box");
    if (items.length === 0) {
      filterContainer.style.display = "none";
    } else {
      filterContainer.style.display = "";
    }
  },
);
